// extracted by mini-css-extract-plugin
export default {"root":"_2PIRA","normal":"_13NmM","small":"_3K54i"};